import { createContext, FC, ReactNode, useState } from 'react'
import { CookieKeys, CookieService } from '@/services/cookie'
import dayjs from 'dayjs'

interface AuthContextType {
  isAuthorized: boolean
  authorize: (token: string) => void
  logout: () => void
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const AuthProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState<boolean>(!!CookieService.getItem(CookieKeys.RegistrantToken))

  const authorize = (token: string) => {
    const today = dayjs()
    const year = today.year()
    const endOfJune = dayjs(`${year}-06-30 23:59:59`) // 30 June 23:59:59
    const endOfDecember = dayjs(`${year}-12-31 23:59:59`) // 31 December 23:59:59
    const expires = today.isBefore(endOfJune) ? endOfJune : endOfDecember

    CookieService.setItem(CookieKeys.RegistrantToken, token, {
      expires: expires.toDate(),
    })

    setIsAuthorized(true)
  }

  const logout = () => {
    CookieService.removeItem(CookieKeys.RegistrantToken)
    setIsAuthorized(false)
  }

  return <AuthContext.Provider value={{ isAuthorized, authorize, logout }}>{children}</AuthContext.Provider>
}
